import { render } from "./banneradd.vue?vue&type=template&id=1583a468&scoped=true"
import script from "./banneradd.vue?vue&type=script&lang=js"
export * from "./banneradd.vue?vue&type=script&lang=js"

import "./banneradd.vue?vue&type=style&index=0&id=1583a468&scoped=true&language=stylus&rel=stylesheet%2Fstylus&lang=css"
import "./banneradd.vue?vue&type=style&index=1&id=1583a468&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1583a468"]])

export default __exports__